var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mcu-selector',{attrs:{"movieModel":_vm.movieModel},on:{"update-order":_vm.updateOrderingSelection}}),_vm._v(" "),_c('mcu-movie-list',{attrs:{"movieModel":_vm.movieModel,"ordering":_vm.selectedOrder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }